import React, { useState } from 'react';
import { Sparkles, RefreshCw, AlertTriangle } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

const INTEREST = {
  alto: { label: 'Interés alto', bg: 'rgba(34,197,94,0.15)', color: '#22c55e' },
  medio: { label: 'Interés medio', bg: 'rgba(234,179,8,0.15)', color: '#eab308' },
  bajo: { label: 'Interés bajo', bg: 'rgba(100,116,139,0.15)', color: '#64748b' },
};

const parse = (v) => { if (!v) return null; if (typeof v === 'object') return v; try { return JSON.parse(v); } catch { return null; } };
const fmt = (d) => { const dt = new Date(d); return isNaN(dt) ? '' : dt.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); };

// Análisis IA breve de una conversación. conv: { id, ai_summary, ai_summary_at, ai_summary_msgs, msg_count }
export default function AiAnalysis({ conv, onUpdated, canGenerate = true }) {
  const [busy, setBusy] = useState(false);
  const data = parse(conv?.ai_summary);
  const newMsgs = data && conv.msg_count ? Math.max(0, conv.msg_count - (conv.ai_summary_msgs || 0)) : 0;

  const run = async () => {
    setBusy(true);
    try { const r = await api.post('/conversations/' + conv.id + '/analyze'); toast.success(r.data.cached ? 'No hay mensajes nuevos: el análisis ya está al día' : 'Análisis actualizado'); onUpdated && onUpdated(); }
    catch (e) { toast.error(e.response?.data?.error || 'No se pudo analizar', { duration: 6000 }); }
    finally { setBusy(false); }
  };

  const it = data ? (INTEREST[data.interes] || INTEREST.medio) : null;
  const row = { fontSize: 12, lineHeight: 1.45, marginTop: 6 };
  const key = { color: 'var(--text-muted)', fontWeight: 600 };

  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 10, padding: '10px 12px', background: 'var(--bg-secondary)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--text-muted)' }}>
          <Sparkles size={13} color="var(--accent)" /> Análisis IA
          {it && <span className="badge" style={{ fontSize: 10, background: it.bg, color: it.color, textTransform: 'none' }}>{it.label}</span>}
        </div>
        {canGenerate && (
          <button className="btn btn-ghost btn-sm" onClick={run} disabled={busy || (data && newMsgs === 0)} title={data && newMsgs === 0 ? 'El análisis está al día: no hay mensajes nuevos' : ''} style={{ fontSize: 11, gap: 4, padding: '2px 8px' }}>
            {busy ? 'Analizando...' : data ? newMsgs > 0 ? <><RefreshCw size={11} /> Actualizar (+{newMsgs})</> : 'Al día' : <><Sparkles size={11} /> Analizar</>}
          </button>
        )}
      </div>
      {data ? (<>
        <div style={{ ...row, color: 'var(--text-primary)' }}>{data.resumen}</div>
        {data.servicio_interes && <div style={row}><span style={key}>Servicio de interés: </span>{data.servicio_interes}</div>}
        {data.necesidad && <div style={row}><span style={key}>Busca: </span>{data.necesidad}</div>}
        {data.proximo_paso && <div style={row}><span style={key}>Próximo paso: </span>{data.proximo_paso}</div>}
        {data.alerta && <div style={{ ...row, color: '#f97316', display: 'flex', gap: 5 }}><AlertTriangle size={12} style={{ flexShrink: 0, marginTop: 2 }} />{data.alerta}</div>}
        <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 6 }}>Generado {fmt(conv.ai_summary_at)}</div>
      </>) : (
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>Todavía no hay análisis. Se genera solo cuando el agente deriva a un humano, o tocá "Analizar".</div>
      )}
    </div>
  );
}
